export default __webpack_public_path__ + "static/figure1-af740ed1ba314b3196bae4081ed294d3.webp";